<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("subject.manage_subject") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success btn-search ml-6"
      @click="go2AddPage"
    >
      {{ $t("common.add_new") }}
    </md-button>
  </div>
</template>

<script>
import { subject_router_names } from "@/routes/routes";
import { Subject } from "@/constants/Permissions";

export default {
  name: "ListPageHeader",
  computed: {
    canAdd() {
      return this.$can(Subject.actions.add, Subject.subject);
    }
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: subject_router_names.addPage });
    }
  }
};
</script>
